import { createAction } from "@reduxjs/toolkit"

export const setModalBuyNow = createAction<any>("modal/setModalBuyNow")
export const setModalBidNow = createAction<any>("modal/setModalBidNow")
export const setModalSuccess = createAction<any>("modal/setModalSuccess")
export const setModalAddFund = createAction<any>("modal/setModalAddFund")
export const setModalConnectWallet = createAction<any>(
  "modal/setModalConnectWallet"
)
